<template>
    <picture>
        <source
            v-for="source in settings.sources"
            :srcset="source.srcset"
            :type="source.type"
            :media="source.media"
        >
        <img
            :src="settings.default.path"
            :width="settings.default.width"
            :height="settings.default.height"
            :loading="lazyLoad ? 'lazy' : 'eager'"
            draggable="false"
            :alt="settings.default.alt"
            :style="imgStyle"
        >
    </picture>
</template>

<script setup lang="ts">
import {computed} from 'vue';

interface Props {
    settings: any;
    color?: string | null;
    lazyLoad?: boolean;
}

const {settings, color = null, lazyLoad = true} = defineProps<Props>();

const imgStyle = computed(() => {
    const style: Record<string, string> = {};
    if (color) {
        style.backgroundColor = color;
    }
    return style;
});
</script>
